module.exports = __webpack_public_path__ + "static/media/Upload Icon.d2532b8f.png";